var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.fdPrgmCategoryGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.fdPrgmCategoryGetErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.stockGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockGetErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.fdPrgmPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.fdPrgmPostErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.editMode
                ? _c("v-autocomplete", {
                    attrs: {
                      label: "Stock",
                      items: _vm.stockList,
                      loading: _vm.stockGetting,
                      disabled: !_vm.stockList.length,
                      "item-text": "description",
                      "error-messages": _vm.fdPrgmPostErrors.stock_id,
                      "return-object": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function({ item }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "stocks-description blue-grey--text"
                                },
                                [_vm._v(_vm._s(item.description))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2931978224
                    ),
                    model: {
                      value: _vm.stock,
                      callback: function($$v) {
                        _vm.stock = $$v
                      },
                      expression: "stock"
                    }
                  })
                : _c("v-text-field", {
                    attrs: { label: "Stock", value: _vm.stockId, disabled: "" }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Feeding Program Category",
                  disabled: !_vm.fdPrgmCategoryList.length,
                  "item-value": "id",
                  "item-text": "description",
                  loading: _vm.fdPrgmCategoryGetting,
                  items: _vm.fdPrgmCategoryList,
                  "error-messages":
                    _vm.fdPrgmPostErrors.feeding_program_category_id
                },
                model: {
                  value: _vm.feedingProgramCategoryId,
                  callback: function($$v) {
                    _vm.feedingProgramCategoryId = $$v
                  },
                  expression: "feedingProgramCategoryId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Day Start",
                  "error-messages": _vm.fdPrgmPostErrors.day_start,
                  type: "number"
                },
                model: {
                  value: _vm.dayStart,
                  callback: function($$v) {
                    _vm.dayStart = $$v
                  },
                  expression: "dayStart"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Day End",
                  "error-messages": _vm.fdPrgmPostErrors.day_end,
                  type: "number"
                },
                model: {
                  value: _vm.dayEnd,
                  callback: function($$v) {
                    _vm.dayEnd = $$v
                  },
                  expression: "dayEnd"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Body Weight",
                  type: "number",
                  "error-messages": _vm.fdPrgmPostErrors.body_weight
                },
                model: {
                  value: _vm.bodyWeight,
                  callback: function($$v) {
                    _vm.bodyWeight = $$v
                  },
                  expression: "bodyWeight"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Expected Weight",
                  "error-messages": _vm.fdPrgmPostErrors.expected_weight,
                  type: "number"
                },
                model: {
                  value: _vm.expectedWeight,
                  callback: function($$v) {
                    _vm.expectedWeight = $$v
                  },
                  expression: "expectedWeight"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        [
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                dense: "",
                small: "",
                dark: "",
                loading: _vm.fdPrgmPosting
              },
              on: { click: _vm.sendServerRequest }
            },
            [_c("span", [_vm._v("Save")])]
          ),
          _vm.editMode
            ? _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: { color: "error", dense: "", small: "", dark: "" },
                  on: { click: _vm.closeEditMode }
                },
                [_c("span", [_vm._v("Cancel")])]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }